import { MatDialogConfig } from '@angular/material';

export class DialogConfigBase {

  // default material dialog configuration
  private configBase: MatDialogConfig = {
    closeOnNavigation: false
  };

  constructor() { }

  protected buildConfig(data: any, otherConfig: MatDialogConfig): MatDialogConfig {
    return {
      ...this.configBase,
      ...otherConfig,
      data: data
    }
  }
}
